/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Testimonials_EyebrowInputs */

const en_why_listening_testimonials_eyebrow = /** @type {(inputs: Why_Listening_Testimonials_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From people who switched`)
};

const es_why_listening_testimonials_eyebrow = /** @type {(inputs: Why_Listening_Testimonials_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De quienes se cambiaron`)
};

/**
* | output |
* | --- |
* | "From people who switched" |
*
* @param {Why_Listening_Testimonials_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_testimonials_eyebrow = /** @type {((inputs?: Why_Listening_Testimonials_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Testimonials_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_testimonials_eyebrow(inputs)
	return en_why_listening_testimonials_eyebrow(inputs)
});